var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-youtube-iframe"},[(_vm.hasYoutubeVideoId)?_c('youtube',{ref:"youtube",attrs:{"video-id":_vm.youtubeVideoId,"fit-parent":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }